import React from 'react'

function Header({ courseTitle}) {
   return (
      <nav className="fixed top-0 left-0 w-full right-0 z-[100] px-4 md:px-6 items-center bg-white shadow-sm">
         <div className="w-full h-[70px] md:h-[92px] flex items-center justify-between">
            <div className="flex items-center">
               <a href="/" className="flex items-center">
                  {/* Logo pour le mode light */}
                  <img
                     src="/Logo NextMaker.png"
                     alt="logo"
                     className="h-8 md:h-[35px] block dark:hidden"
                  />
               </a>
            </div>

            <div className='hidden md:block flex-1 px-4'>
               <div className="text-base md:text-xl text-dark-1 text-center font-medium truncate">
                  {courseTitle}
               </div>
            </div>

            <div className="flex items-center justify-end ">
               <a href="/dashboard">
                  <button className="h-[50px] px-[30px] bg-purple-1 border-2 border-purple-1
                            rounded-full font-medium text-white hover:bg-transparent hover:text-purple-1 transition-colors">
                     Dashboard
                  </button>
               </a>
            </div>
         </div>
      </nav>
   )
}

export default Header